import React, { useEffect, useMemo, useState, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { Checkbox, Divider, Paper, Tooltip, Typography } from "@material-ui/core";
import { unoTheme } from "../../../assets/styles/unoTheme";

//Tables
import Table from '@material-ui/core/Table';
import MyTable from '../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import MyTextField from "../../utils/MyTextField";
import MyAlertBalance from "../../utils/MyAlertBalance";
import MyTextFieldRef from "../../utils/MyTextFieldRef";

import UnoButton from "../../utils/UnoButton";

import IconButton from '@material-ui/core/IconButton';

import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

//Redux
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../actions";

import {
    getArrayMonthsWithNames,
    applyMaskAmount,
    applyMaskAccount,
    parseFloatByPtCurrency,
    applyCurrencyMask,
    getMonthName,
    formatAnbimaDateToPt,
    applyMaskAmountFreeDecimals,
    getOperationLabel,
} from "../../utils/utils";

import { CONSOLIDATED_SELECT_VALUE, getRegimeOptions } from "../../utils/accountRegimes";
import { ClientAPI } from "../../../API/client";

//MyInputs
import MySelect from '../../utils/MySelect'
import MyDatePicker from '../../utils/MyDatePicker'

import _ from 'lodash';
import moment from 'moment'

import CircularProgress from '@material-ui/core/CircularProgress';

import EventIcon from '@material-ui/icons/Event';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import QuotizationAssetModal from '../../modals/QuotizationAssetModal';
import { isGenericTitle } from "../../../controllers/TitleController";
import { checkUserIsRole, roles } from "../../utils/user";

import XLSX from 'xlsx';
import { s2ab, downloadBlob } from '../../../controllers/ExcelController';
import { TransactionAPI } from "../../../API/transaction";
import { TitleLocalQuotasAPI } from "../../../API/title_local_quotas";


const bottomHeight = 40;
//const headerHeight = 170;
const headerHeight = 196;
//const headerHeight = 187;

const useStyles = makeStyles((theme) => ({
    root: {
        //height: '100vh',
        width: '100%',
    },

    header: {
        display: 'flex',
        flexDirection: 'column',
        //height: headerHeight,        
        backgroundColor: unoTheme.hoverTable,
        paddingBottom: '2px',
    },

    topHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        // paddingTop: theme.spacing(2),
        paddingTop: '12px',
        // paddingBottom: theme.spacing(2),
        paddingBottom: '12px',

        '& .actionButtonsHeader': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        }
    },

    bottomHeader: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: theme.spacing(3),
        paddingTop: '12px',
        paddingBottom: '12px',
        borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)'
    },

    main: {
        //paddingBottom: theme.spacing(2),
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
        //paddingTop: theme.spacing(2),
        height: 'calc(100% - ' + (headerHeight) + 'px)',

        // '& .mainTable': {
        //     //height: 'calc(100% - ' + (headerHeight + bottomHeight) + 'px)',
        //     height: 'calc(100% - ' + (headerHeight) + 'px)',
        // },

        '& .alertMain': {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            textAlign: 'left',
        }
    },

    bottom: {
        height: bottomHeight,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },

    spacingRight2: {
        marginRight: theme.spacing(2),
    },

    table: {
        height: 'calc(100% - 1px)',
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: '#1C2228',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px',
            },
        },
    },

    // detailRow: {
    //     cursor: "pointer",
    //     '& > *': {
    //         borderBottom: 'unset',
    //         padding: '3px 16px 3px 16px !important',
    //         textTransform: 'uppercase',
    //         color: unoTheme.defaultTextColor,
    //         fontWeight: 400,
    //         fontSize: '12px',
    //     },
    //     '&:nth-of-type(odd)': {
    //         backgroundColor: unoTheme.secondaryTuplaTable,
    //     },

    // },

    flexCell: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        justifyItems: 'center',
        height: '100%',
        paddingLeft: '0px !important',

        '& .MuiTypography-root': {
            fontWeight: 400,
            fontSize: '12px',
        },
    },
    statusOff: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusOk: {
        color: unoTheme.greenMoney,
        fill: unoTheme.greenMoney,
    },
    statusPendent: {
        color: unoTheme.warningColor,
        fill: unoTheme.warningColor,
    },
    marginLeft: {
        marginLeft: '5px',
    },
    leftHeader: {

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    labelYear: {
        fontSize: '36px',
        paddingRight: theme.spacing(2),
    },
    spacingLeft1: {
        marginLeft: theme.spacing(1)
    },
    spacingLeft2: {
        marginLeft: theme.spacing(2)
    },

    disableMonth: {
        position: 'absolute',
        height: '100%',
        width: '100%',
    },
    green: {
        color: unoTheme.greenMoney + ' !important'
    },
    red: {
        color: unoTheme.errorColor + ' !important',
    },
    blue: {
        color: 'blue !important',
    },
    warning: {
        color: unoTheme.warningColor
    },
    labelTotal: {
        fontSize: '13px',
        color: unoTheme.thirdColor
    },
    resultAmount: {
        fontSize: '13px',
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1)
    },
    headerTotal: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',

        '& .infosHeaderTotal': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',

            '& .numberQuotas': {
                cursor: 'pointer',
                padding: '0px',
                margin: '0px',
                fontSize: '12px',
                textAlign: 'left',
                transition: 'all .3s ease',

                '&:hover': {
                    color: '#aaaaaa',
                }
            }
        }

    },
    leftHeader: {
        display: 'flex',
        //alignItems: 'center',
        flexDirection: 'column',
    },
    headerDate: {
        display: 'flex',
        alignItems: 'center',
        color: unoTheme.secondaryColor,
        fontSize: '12px',
        '& svg': {
            marginRight: '5px',
        },
        '& > *': {
            fontSize: '14px',
        }
    },

    cnpjLabel: {
        cursor: 'pointer',
        fontSize: '14px',
        color: unoTheme.secondaryColor,

        transition: 'all .3s ease',

        '&:hover': {
            color: '#615b5b',
        }
    },

    fundLabel: {
        fontSize: '20px',
        fontWeight: 'bold',
        color: '#1C2228'
    },

    rightDivBackdrop: {
        backgroundColor: 'white',
        position: 'absolute',
        opacity: 0.7,
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .progress': {
            color: unoTheme.mainColor
        }
    },
    validationMessage: {
        color: unoTheme.errorColor,
        fontSize: '14px',
        textAlign: 'right',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
    alertBalance: {
        marginBottom: '5px',
        '& .MuiAlert-message': {
            fontSize: '12px',
            padding: '0px',
            '& span': {
                verticalAlign: 'middle',
            }
        },
        '& .MuiAlert-icon': {
            padding: '0px',
        }
    },

    tabsAsset: {
        background: '#F3F5F8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },

    selectableInfo: {

        transition: 'all .3s ease',

        '&:hover': {
            color: '#aaaaaa',
        }
    },

    cnpjAndFilterRegime: {

        display: 'flex',
        alignItems: 'center',
        //justifyContent: 'center',
    },

    lastQuotasInfo: {
        display: 'flex',
        alignItems: 'center',
        '& span': {
            fontSize: '12px',
        }
    },

    bold: {
        fontWeight: 'bold',
        cursor: 'pointer',

        '&:hover': {
            opacity: 0.7,
        }
    },

    shortWidthTab: {
        '& .MuiTab-root': {
            minWidth: '0px !important',
        }
    },



}));

export default function DetailBalanceCollection(props) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.currentUser)
    const clientOn = useSelector(state => state.clientOn)

    const { content } = props

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [openQuotizationAssetModal, setOpenQuotizationAssetModal] = useState(false);

    //Copy to DAIR
    const textRef = useRef(null);
    //Filtro de regime: as options usam o id do regime como value, então não há mais conversão
    //entre índice do select e id
    const regimeOptions = useMemo(
        () => getRegimeOptions(clientOn, {
            includeConsolidated: true,
            consolidatedLabel: 'Consolidado',
        }),
        [clientOn]);
    const [selectedRegimeType, setSelectedRegimeType] = useState(CONSOLIDATED_SELECT_VALUE); //detail
    function handleRegimeType(value) {

        //O MySelect devolve string; '0' é truthy, daí o parse explícito
        const regimeId = parseInt(value) || CONSOLIDATED_SELECT_VALUE;

        setSelectedRegimeType(regimeId)
        loadTotalInfosObject(content.data.transactions, regimeId);
    }

    //Filtro de contas 
    const [numberAccountOptions, setNumberAccountsOptions] = useState([]);
    const [selectedNumberAccountOption, setSelectedNumberAccountOption] = useState(0); //detail
    // function handleRegimeType(value) {
    //     setSelectedRegimeType(value)
    //     loadTotalInfosObject(content.data.transactions, value);
    // }

    const [totalInfosObject, setTotalInfosObject] = useState({
        totalApplications: 0,
        totalApplicationsQuotas: 0,
        totalRescues: 0,
        totalRescuesQuotas: 0,
    });

    function loadTotalInfosObject(transactions, regimeType) {

        //Existe a possibilidade de não haver transações para o ativo selecionado

        if (transactions) {


            let totalApplications = 0;
            let totalApplicationsQuotas = 0;
            let totalRescues = 0;
            let totalRescuesQuotas = 0;

            //Caso o regimeType seja 0 deve-se tratar os totais a partir de todas as transações, informação consolidada
            const transactionsInTheRegime = regimeType == 0 ?
                transactions
                :
                transactions.filter(transaction => transaction.account_regime_id == regimeType);

            console.log("TRASANCTIONS TO TOTAL: ", transactionsInTheRegime);

            if (transactionsInTheRegime) {
                transactionsInTheRegime.forEach(element => {

                    if (element.operation_id == 1) {

                        totalApplications += element.amount ? parseFloat(element.amount) : 0;
                        totalApplicationsQuotas += element.result_qtd_quotas ? element.result_qtd_quotas : 0;

                    } else if (element.operation_id == 2) {

                        totalRescues += element.amount ? parseFloat(element.amount) : 0;
                        totalRescuesQuotas += element.result_qtd_quotas ? element.result_qtd_quotas : 0;

                    }

                });

                setTotalInfosObject({
                    totalApplications: totalApplications,
                    totalApplicationsQuotas: totalApplicationsQuotas,
                    totalRescues: totalRescues,
                    totalRescuesQuotas: totalRescuesQuotas,
                });
            }

        }



    }

    //Tab de saldos do ano ou descrição do ativo
    const [tabValue, setTabValue] = useState(0); //detail
    function handleChangeTabValue(event, value) {
        setTabValue(value)
    }

    function copyToClipboard(e, text) {
        e.stopPropagation();
        navigator.clipboard.writeText(text);
        dispatch(allActions.mainAlertActions.setMainAlert({
            type: 'success',
            message: 'Informação copiada para área de transferência!',
            show: true,
        }));
    };

    function doEditTransaction(transaction, index) {

        //console.log("T: ", transaction)
        // setEditAmount(applyMaskAmount(transaction.amount))
        // setEditOperation(parseInt(transaction.operation_id) - 1)
        // setEditDate(moment.utc(transaction.transaction_date));
        // setEdittingIndex(index)

        dispatch(allActions.rightContentActions.setRightContent({
            path: 'newTransaction',
            update: true,
            transactionToUpdate: transaction,
            data: { //Utilizado para enviar no retorno da tela
                path: 'detailTitleBalanceCollection',
                data: content.data,
                selectedMonth: content.selectedMonth,
                selectedYear: content.selectedYear,
                accounts: content.accounts,
                assets: content.assets,
                titleAssets: content.titleAssets,
                operations: content.operations
            }
        }))
    }

    const goToCreateTransaction = () => {
        dispatch(allActions.rightContentActions.setRightContent({
            path: 'newTransaction',
            data: {
                path: 'detailTitleBalanceCollection',
                title: content.data,
                selectedMonth: content.selectedMonth,
                selectedYear: content.selectedYear,
                accounts: content.accounts,
                assets: content.assets,
                titleAssets: content.titleAssets,
                operations: content.operations
            }
        }))
    }

    async function doConcilio(balanceId) {

        //open backdrop
        setOpenBackdrop(true);

        let response = await ClientAPI.setBalanceReconciliaded(balanceId,
            currentUser.user.id,
            true, 'title');

        if (response.success) {

            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'success',
                message: 'Conciliação realizada com sucesso!'
            }))
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Erro ao realizar conciliação!'
            }))
        }

        dispatch(allActions.rightContentActions.setAction({
            task: 'updateConcilio',
            data: {
                balanceId: balanceId,
            },
        }))
        setOpenBackdrop(false);
    }

    function getAccountsWithTransactions(transactions) {

        let accountsWithTransactions = ["Conta"];

        if (!transactions) {
            return accountsWithTransactions;
        }

        transactions.forEach(t => {

            if (!accountsWithTransactions.includes(t.account)) {
                accountsWithTransactions.push(t.account);
            }

        });

        return accountsWithTransactions;
    }

    async function doExcelTransactionsHistory() {

        setOpenBackdrop(true);

        try {

            //Um título pode estar agrupado em mais de um registro de asset (várias contas)
            //A conta (number_account) está vinculada ao asset, não à transação:
            //cada asset corresponde a uma conta, então as transações herdam a conta do asset consultado
            const assetRecords = content.data.subAssetsTitles && content.data.subAssetsTitles.length > 0
                ? content.data.subAssetsTitles
                : [content.data];

            const responses = await Promise.all(assetRecords.map(asset => TransactionAPI.getTransactionsByAssetTitle(asset.id)));

            let allTransactions = [];
            responses.forEach((response, index) => {
                if (response.success && response.body && response.body.rows) {
                    const asset = assetRecords[index];
                    //Marca cada transação com a conta do asset de origem
                    const taggedRows = response.body.rows.map(row => ({
                        ...row,
                        _number_account: asset.number_account,
                    }));
                    allTransactions = allTransactions.concat(taggedRows);
                }
            });

            //Respeita o filtro de conta selecionado na tela (selectedNumberAccountOption)
            //Índice 0 = "Conta" (todas as contas)
            if (selectedNumberAccountOption != 0) {
                const selectedAccountNumber = numberAccountOptions[selectedNumberAccountOption];
                allTransactions = allTransactions.filter(t => t._number_account == selectedAccountNumber);
            }

            if (allTransactions.length === 0) {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'warning',
                    message: 'Nenhuma movimentação encontrada para esse título!'
                }));
                setOpenBackdrop(false);
                return;
            }

            //Ordena por data da operação (ascendente)
            allTransactions.sort((a, b) => moment.utc(a.transaction_date).diff(moment.utc(b.transaction_date)));

            //Busca todos os PUs locais do título (todos os meses) e monta um mapa por data (DD/MM/YYYY)
            //O PU (valor de cota do dia) não vem confiável na transação, fica armazenado em title_local_quotas
            const puByPtDate = {};
            const responseQuotas = await TitleLocalQuotasAPI.loadAllQuotasTitleById(content.data.title_id);
            if (responseQuotas.success && responseQuotas.body && Array.isArray(responseQuotas.body.rows)) {
                responseQuotas.body.rows.forEach(monthRow => {
                    try {
                        const jsonQuotas = typeof monthRow.json_quotas === 'string'
                            ? JSON.parse(monthRow.json_quotas)
                            : monthRow.json_quotas;
                        if (Array.isArray(jsonQuotas)) {
                            jsonQuotas.forEach(q => {
                                //date_quota já vem em DD/MM/YYYY; pu_anb é o PU do dia
                                if (q.date_quota != null && q.pu_anb != null) {
                                    puByPtDate[q.date_quota] = Number(q.pu_anb);
                                }
                            });
                        }
                    } catch (e) {
                        console.log("ERROR parsing json_quotas: ", e);
                    }
                });
            }

            //Nome do título (títulos genéricos não exibem marking)
            const titleName = content.data.titleCod
                + (!isGenericTitle(content.data) && content.data.marking ? ' (' + content.data.marking + ')' : '');

            const columns = ['Título', 'Conta', 'Data da operação', 'Operação', 'Quantidade de cotas', 'Valor de cota no dia', 'Valor financeiro'];

            const ws_data = [];
            ws_data.push(columns);
            allTransactions.forEach(t => {

                const ptDate = t.transaction_date ? moment.utc(t.transaction_date).format('DD/MM/YYYY') : null;
                const puValue = ptDate != null && puByPtDate[ptDate] != null ? puByPtDate[ptDate] : null;
                const amount = t.amount != null ? parseFloat(t.amount) : null;

                //Quantidade de cotas = valor financeiro / valor da cota (PU) no dia
                const qtdQuotas = amount != null && puValue != null && puValue > 0
                    ? amount / puValue
                    : null;

                ws_data.push([
                    titleName,
                    t._number_account ? applyMaskAccount(t._number_account) : '-',
                    t.transaction_date ? new Date(t.transaction_date) : null,
                    getOperationLabel(t),
                    qtdQuotas,
                    puValue,
                    amount,
                ]);
            });

            const sheetName = 'Movimentações';
            const fileName = 'Histórico Movimentações - ' + titleName
                + ' - ' + moment.utc(new Date()).format('DD/MM/YYYY');

            const wb = XLSX.utils.book_new();
            wb.Props = {
                Title: fileName,
                Author: 'UNO',
            };
            wb.SheetNames.push(sheetName);
            const ws = XLSX.utils.aoa_to_sheet(ws_data);
            wb.Sheets[sheetName] = ws;

            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
            downloadBlob(
                new Blob([s2ab(wbout)], { type: 'application/octet-stream' }),
                fileName + '.xlsx'
            );

        } catch (error) {
            console.log("ERROR doExcelTransactionsHistory: ", error);
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Erro ao gerar histórico de movimentações!'
            }));
        } finally {
            setOpenBackdrop(false);
        }

    }

    useEffect(() => {

        console.log("DATA DETAIL BALANCE COLLECTION: ", content.data)
        console.log("DATA DETAIL BALANCE COLLECTION ACCOUNTS: ", content.accounts)

        //Fazendo a última cota subir
        // if (content && content.data && content.data.quotas_anbima) {
        //     content.data.quotas_anbima.reverse();
        // }

        //init totalInfosObject
        if (content && content.data) {

            // let arrayNumberAccountsOptions = [];
            // content.accounts.forEach(account => {
            //     arrayNumberAccountsOptions.push(applyMaskAccount(account.number_account));
            // });
            // arrayNumberAccountsOptions.unshift("Contas");

            //setNumberAccountsOptions(arrayNumberAccountsOptions);
            setNumberAccountsOptions(getAccountsWithTransactions(content.data.transactions));
            loadTotalInfosObject(content.data.transactions, 0);
        }


    }, [])

    return (
        <div className={classes.root}>


            <div className={classes.header}>

                <div className={classes.topHeader}>

                    <div className={classes.leftHeader}>
                        <div className={classes.headerDate}>
                            <EventIcon />
                            <Typography
                                align={'left'}

                                className={classes.labelMonth}>
                                {content && content.selectedMonth && content.selectedYear ?
                                    getMonthName(content.selectedMonth).toString().toUpperCase() + " " + content.selectedYear
                                    : ""}
                            </Typography>
                        </div>
                        <Typography
                            align={'left'}
                            className={classes.fundLabel}>
                            {content && content.data ?

                                content.data.titleCod +
                                (!isGenericTitle(content.data) ? '(' + content.data.marking + ')' : "")
                                :
                                ""
                            }

                        </Typography>
                        <div className={classes.cnpjAndFilterRegime}>
                            {
                                !isGenericTitle ?
                                    <Typography
                                        onClick={(e) => copyToClipboard(e, content && content.data ? content.data.marking : "")}
                                        ref={textRef}
                                        align={'left'}
                                        className={classes.cnpjLabel}>
                                        {content && content.data ? content.data.marking : ""}
                                    </Typography> : null
                            }

                            <MySelect
                                style={!isGenericTitle ? { marginLeft: '16px' } : {}}
                                value={selectedRegimeType}
                                verysmall
                                onChange={(e) => handleRegimeType(e.target.value)}
                                options={regimeOptions.map((row) => (

                                    <option key={'regime-' + row.value} value={row.value}>{row.name}</option>

                                ))}
                            />

                        </div>

                    </div>

                    <div className={'actionButtonsHeader'}>

                        <IconButton onClick={() => dispatch(allActions.rightContentActions.setRightContent(null))}>
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>

                <Divider />

                <div className={classes.bottomHeader}>
                    <div className={classes.headerTotal}>
                        <Typography
                            className={classes.labelTotal}>
                            {'APLICAÇÔES: '}
                        </Typography>
                        <div class="infosHeaderTotal">
                            <Typography
                                className={[classes.resultAmount, classes.green].join(' ')}>
                                {applyMaskAmount(totalInfosObject.totalApplications, true)}
                            </Typography>
                            <Typography class="numberQuotas" onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(totalInfosObject.totalApplicationsQuotas, false))}>
                                {"(" + applyMaskAmountFreeDecimals(totalInfosObject.totalApplicationsQuotas, false) + ")"}
                            </Typography>
                        </div>

                    </div>
                    <div className={classes.headerTotal}>
                        <Typography
                            className={classes.labelTotal}>
                            {'RESGATES: '}
                        </Typography>
                        <div class="infosHeaderTotal">
                            <Typography
                                className={[classes.resultAmount, classes.red].join(' ')}>
                                {applyMaskAmount(totalInfosObject.totalRescues, true)}
                            </Typography>
                            <Typography class="numberQuotas" onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(totalInfosObject.totalRescuesQuotas, false))}>
                                {"(" + applyMaskAmountFreeDecimals(totalInfosObject.totalRescuesQuotas, false) + ")"}
                            </Typography>
                        </div>
                    </div>
                    {/* <div className={classes.headerTotal}>
                        <Typography
                            className={classes.labelTotal}>
                            {'TOTAL: '}
                        </Typography>
                        <div>
                            <Typography
                                className={[classes.resultAmount, content.data.resultAmount > 0 ? classes.green : classes.red].join(' ')}>
                                {content.data && content.data.resultAmount ?
                                    applyMaskAmount(content.data.resultAmount, true) : "-"}
                            </Typography>
                            <Typography className={classes.numberQuotas}>
                                {content.data && content.data.sumQuotasApplication && content.data.sumQuotasRescues ?
                                    applyMaskAmountFreeDecimals(content.data.sumQuotasApplication - content.data.sumQuotasRescues, false) : "-"}
                            </Typography>
                        </div>

                    </div> */}



                </div>



                <Paper square className={classes.tabsAsset}>
                    <div className={[classes.tabs, classes.shortWidthTab].join(' ')}>
                        <Tabs
                            value={tabValue}
                            indicatorColor="primary"
                            textColor="primary"
                            onChange={handleChangeTabValue}>

                            <Tab label={'Movimentações'} />
                            <Tab disabled={content && content.data
                                && content.data.title_local_quotas && content.data.title_local_quotas.length > 0} label="PU/IPCAdp" />
                            <Tab label="CDI" />
                            <Tab label="IGPM" />
                            <Tab label="CUPONS" />

                        </Tabs>
                    </div>

                    {/* {
                        tabValue == 0 ?
                            <UnoButton
                                className={classes.spacingRight2}
                                size="verySmall"
                                onClick={() => goToCreateTransaction()}
                                type='warning'>
                                {"+ MOV."}
                            </UnoButton> : null
                    } */}

                    <div className={[classes.lastQuotasInfo, classes.spacingRight2].join(' ')}>
                        {
                            tabValue == 0 ?
                                <UnoButton
                                    size="verySmall"
                                    onClick={() => doExcelTransactionsHistory()}
                                    type='warning'>
                                    {"Hist. Movimentações"}
                                </UnoButton> : null
                        }
                        {
                            content && content.data && content.data.balance_now && content.data.quota_amount_now ?
                                <>
                                    <span className={classes.spacingLeft2}>
                                        PU:
                                    </span>
                                    <span
                                        onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(content.data.balance_now / content.data.quota_amount_now, true, 10))}
                                        className={[classes.bold, classes.spacingLeft1].join(' ')}>{applyMaskAmountFreeDecimals(content.data.balance_now / content.data.quota_amount_now, true, 10)}</span>
                                </> : null
                        }
                    </div>

                </Paper>

            </div>

            {
                tabValue == 0 ?

                    <div className={classes.main}>

                        {
                            //Verificar role
                            checkUserIsRole(currentUser,
                                [roles.admin,
                                roles.superadmin,
                                roles.advisor]) ?
                                <>
                                    {
                                        content.data.subAssets ?

                                            // exibir lista de alertas
                                            content.data.subAssets.map((row, index) => (
                                                <MyAlertBalance
                                                    key={'my-alert-balance-' + index}
                                                    role={currentUser.user ? currentUser.user.role : null}
                                                    row={row}
                                                    action={(param) => doConcilio(param)} />
                                            ))

                                            :

                                            <MyAlertBalance
                                                role={currentUser.user ? currentUser.user.role : null}
                                                row={content.data}
                                                action={(param) => doConcilio(param)} />
                                    }

                                </>
                                : null
                        }

                        <MyTable
                            style={{ marginTop: '8px' }}
                            stickyHeader
                            infosBlack
                            sizeheaders="verySmall"
                            selectable={'true'}
                            size="small">
                            <colgroup>
                                <col width="15%" />
                                <col width="14%" />
                                <col width="16%" />
                                <col width="17%" />
                                <col width="18%" />
                                <col width="20%" />
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableTh} align="center">Data</TableCell>
                                    <TableCell className={classes.tableTh} align="center">Operação</TableCell>
                                    <TableCell className={classes.tableTh} align="center">
                                        <MySelect
                                            rawSelect
                                            value={selectedNumberAccountOption}
                                            verysmall
                                            onChange={(e) => setSelectedNumberAccountOption(e.target.value)}
                                            options={numberAccountOptions.map((row, index) => (

                                                <option key={'account-number-option-' + index} value={index}>{row !== "Conta" ? applyMaskAccount(row) : row}</option>

                                            ))}
                                        />
                                    </TableCell>
                                    <TableCell className={classes.tableTh} align="right">Cotas</TableCell>
                                    <TableCell className={classes.tableTh} align="right">P.U</TableCell>
                                    <TableCell className={classes.tableTh} align="right">Valor</TableCell>
                                    {/* <TableCell className={classes.tableTh} align="center"></TableCell> */}
                                </TableRow>
                            </TableHead>

                            {
                                content && content.data && content.data.transactions ?

                                    <TableBody>
                                        {
                                            //content.data.transactions.map((row, index) => (
                                            content.data.transactions.filter(
                                                el =>
                                                    (selectedRegimeType == 0 || el.account_regime_id == selectedRegimeType)
                                                    &&
                                                    (selectedNumberAccountOption == 0 || el.account == numberAccountOptions[selectedNumberAccountOption])
                                            ).map((row, index) => (


                                                <TableRow className={classes.detailRow}
                                                    key={'detail-transaction-' + index}
                                                    onClick={() =>

                                                        //Verificar role
                                                        checkUserIsRole(currentUser,
                                                            [roles.admin,
                                                            roles.superadmin,
                                                            roles.advisor]) ?
                                                            doEditTransaction(row, index) : null
                                                    }>


                                                    <TableCell align="center" className={classes.selectableInfo}
                                                        onClick={(e) => copyToClipboard(e, moment.utc(row.transaction_date).format('DD/MM/YYYY'))}>
                                                        {moment.utc(row.transaction_date).format('DD/MM/YYYY')}
                                                    </TableCell>

                                                    <TableCell align="center" style={{ fontSize: '10px' }}>
                                                        {row.operation}
                                                    </TableCell>

                                                    <TableCell align="center" >
                                                        {applyMaskAccount(row.account)}
                                                    </TableCell>

                                                    <TableCell align="right" className={classes.selectableInfo} onClick={(e) => copyToClipboard(e, applyMaskAmountFreeDecimals(row.quota_value_transaction))}>
                                                        {row && row.quota_value_transaction ?
                                                            applyMaskAmountFreeDecimals(row.quota_value_transaction) : '-'}
                                                    </TableCell>

                                                    {
                                                        //P.U da transação = valor / quantidade de cotas
                                                        (() => {
                                                            const qtdQuotas = row.quota_value_transaction ? parseFloat(row.quota_value_transaction) : 0;
                                                            const pu = row.amount && qtdQuotas > 0 ? parseFloat(row.amount) / qtdQuotas : null;
                                                            return (
                                                                <TableCell align="right" className={pu != null ? classes.selectableInfo : null}
                                                                    onClick={(e) => pu != null ? copyToClipboard(e, applyMaskAmountFreeDecimals(pu, true, 10)) : null}>
                                                                    {pu != null ? applyMaskAmountFreeDecimals(pu, true, 10) : '-'}
                                                                </TableCell>
                                                            );
                                                        })()
                                                    }

                                                    <TableCell align="right" className={
                                                        row.operation == 'Aplicação' ? classes.green : (row.operation == 'Resgate' ? classes.red : classes.blue)
                                                    }>
                                                        {row && row.amount ? applyMaskAmount(row.amount, true) : null}
                                                    </TableCell>



                                                    {/* <TableCell align="center">
                                                        <Tooltip arrow placement={'left'} title={'Editar'}>
                                                            <IconButton size={'small'}
                                                                onClick={() => doEditTransaction(row, index)}>
                                                                <EditIcon />
                                                            </IconButton>

                                                        </Tooltip>

                                                    </TableCell> */}

                                                </TableRow>



                                            ))

                                        }
                                    </TableBody>
                                    : null
                            }

                        </MyTable>

                    </div>

                    :

                    null


            }



            {/* IPCA */}
            {
                tabValue == 1 ?
                    <div className={classes.main}>


                        <MyTable
                            style={{ marginTop: '8px' }}
                            stickyHeader
                            sizeheaders="verySmall"
                            size="small">
                            <colgroup>
                                <col width="30%" />
                                <col width="30%" />
                                <col width="40%" />
                            </colgroup>

                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Data</TableCell>
                                    <TableCell align="right">PU ANB</TableCell>
                                    <TableCell align="right">IPCAdp</TableCell>
                                </TableRow>
                            </TableHead>

                            {
                                content && content.data && content.data.title_local_quotas ?

                                    <TableBody>
                                        {
                                            content.data.title_local_quotas.map((row, index) => (


                                                <TableRow className={classes.detailRow}
                                                    key={'detail-quota-' + index}>

                                                    <TableCell align="center">
                                                        {row.date_quota}
                                                    </TableCell>

                                                    <TableCell align="right" className={classes.green}>
                                                        {row.pu_anb ? applyMaskAmountFreeDecimals(row.pu_anb, true, 10) : '-'}
                                                    </TableCell>

                                                    <TableCell align="right" className={classes.blue}>
                                                        {content.data.ipcadp_local && content.data.ipcadp_local[index]
                                                            && content.data.ipcadp_local[index].date === row.date_quota ? applyMaskAmountFreeDecimals(content.data.ipcadp_local[index].ipca_dp, true, 8) : '-'}
                                                    </TableCell>


                                                </TableRow>



                                            ))

                                        }
                                    </TableBody>
                                    : null
                            }

                        </MyTable>


                    </div> : null

            }

            {/* CDI */}
            {
                tabValue == 2 ?
                    <div className={classes.main}>


                        <MyTable
                            style={{ marginTop: '8px' }}
                            stickyHeader
                            sizeheaders="verySmall"
                            size="small">
                            <colgroup>
                                <col width="30%" />
                                <col width="70%" />
                            </colgroup>

                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Data</TableCell>
                                    <TableCell align="right">Valor CDI</TableCell>
                                </TableRow>
                            </TableHead>

                            {
                                content && content.data && content.data.cdi_month ?

                                    <TableBody>
                                        {
                                            content.data.cdi_month.map((row, index) => (


                                                <TableRow className={classes.detailRow}
                                                    key={'detail-cdi-' + index}>

                                                    <TableCell align="center">
                                                        {row.date}
                                                    </TableCell>

                                                    <TableCell align="right" className={classes.green}>
                                                        {row.value ? applyMaskAmountFreeDecimals(row.value, true, 8) : '-'}
                                                    </TableCell>

                                                </TableRow>



                                            ))

                                        }
                                    </TableBody>
                                    : null
                            }

                        </MyTable>


                    </div> : null

            }

            {/* IGPM */}
            {
                tabValue == 3 ?
                    <div className={classes.main}>


                        <MyTable
                            style={{ marginTop: '8px' }}
                            stickyHeader
                            sizeheaders="verySmall"
                            size="small">
                            <colgroup>
                                <col width="30%" />
                                <col width="70%" />
                            </colgroup>

                            <TableHead>
                                <TableRow>
                                    <TableCell align="center">Data</TableCell>
                                    <TableCell align="right">Valor IGPM</TableCell>
                                </TableRow>
                            </TableHead>

                            {
                                content && content.data && content.data.igpm_month ?

                                    <TableBody>
                                        {
                                            content.data.igpm_month && content.data.igpm_month.map((row, index) => (


                                                <TableRow className={classes.detailRow}
                                                    key={'detail-igpm-' + index}>

                                                    <TableCell align="center">
                                                        {row.date}
                                                    </TableCell>

                                                    <TableCell align="right" className={classes.green}>
                                                        {row.value ? applyMaskAmountFreeDecimals(row.value, true, 8) : '-'}
                                                    </TableCell>

                                                </TableRow>



                                            ))

                                        }
                                    </TableBody>
                                    : null
                            }

                        </MyTable>


                    </div> : null

            }

            {/*CUPONS*/}

            {
                tabValue == 4 ?
                    <div className={classes.main}>

                        <MyTable
                            style={{ marginTop: '8px' }}
                            stickyHeader
                            infosBlack
                            sizeheaders="verySmall"
                            selectable={'true'}
                            size="small">
                            <colgroup>
                                <col width="30%" />
                                <col width="70%" />
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableTh} align="center">Data</TableCell>
                                    <TableCell className={classes.tableTh} align="right">Valor</TableCell>
                                </TableRow>
                            </TableHead>

                            {
                                content && content.data && content.data.historicAmortizations ?

                                    <TableBody>
                                        {
                                            //content.data.transactions.map((row, index) => (
                                            content.data.historicAmortizations.map((row, index) => (

                                                <TableRow className={classes.detailRow}
                                                    key={'detail-transaction-cupon-' + index}>

                                                    <TableCell align="center" className={classes.selectableInfo}
                                                        onClick={(e) => copyToClipboard(e, moment.utc(row.transaction_date).format('DD/MM/YYYY'))}>
                                                        {moment.utc(row.transaction_date).format('DD/MM/YYYY')}
                                                    </TableCell>

                                                    <TableCell align="right" className={classes.blue}>
                                                        {row && row.amount ? applyMaskAmount(row.amount, true) : null}
                                                    </TableCell>


                                                </TableRow>

                                            ))

                                        }
                                    </TableBody>
                                    : null
                            }

                        </MyTable>

                    </div> : null

            }

            {
                openBackdrop ?
                    <div className={classes.rightDivBackdrop}>
                        <CircularProgress className={'progress'} />
                    </div> : null
            }

            <QuotizationAssetModal
                open={openQuotizationAssetModal}
                asset={content
                    && content.data}
                handleCloseQuotizationModal={() => setOpenQuotizationAssetModal(false)}>

            </QuotizationAssetModal>

        </div >
    );
}



